<script lang="ts">
    import { Col, Input, Label, Row } from 'sveltestrap';
    import { AboutMe, Country} from '../../../../utils/Constant/Constant';
    import data from "../../../../Data/Users/Users.json"
</script>
<Row>
    {#each data.editprofiledata as userItem }
        <Col md={userItem.md} sm={userItem.sm}>
            <div class="mb-3">
            <Label>{userItem.title}</Label>
            <Input type={userItem.type} placeholder={userItem.placeholder} />
            </div>
        </Col>
    {/each}
    <Col md="5">
        <div class="mb-3">
          <Label>{ Country}</Label>
          <Input type="select" name="select" id="exampleSelect" value="--Select--">
            <option>{'--Select--'}</option>
            <option>{'Germany'}</option>
            <option>{'Canada'}</option>
            <option>{'Usa'}</option>
            <option>{'Aus'}</option>
          </Input>
        </div>
    </Col>
    <Col md="12">
        <div>
          <Label>{AboutMe}</Label>
          <textarea
            class="form-control"
            rows="5"
            placeholder="Enter About your description" />
        </div>
    </Col>
</Row>